<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-12 left">
          <div class="title">
            {{ $t('sidebar.configuration') }} > {{ $t('sidebar.settings') }}
          </div>
        </div>
      </div>
    </div>

    <div
      class="content col-md-12"
      style="background: var(--bg-grey-color);">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-else>
        <section class="col-12 no-padding">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('apps.pos.message.possale')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.usefeaturequeue') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <div class="box-input">
                    <vs-checkbox
                      v-model="settings.queue.is_active"
                      :disabled="settings.menu_online.is_active"
                      color="#A3CA76"
                      style="float: left;position: relative;top: 1px;left: -5px;">
                      <span v-if="!settings.queue.is_active">{{ $t('message.disabled') }}</span>
                      <span v-else>{{ $t('message.enabled') }}</span>
                    </vs-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-md-6"/>
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.usefeaturetable') }}
                </div>
                <div
                  class="form-group col-12 mb-0"
                  style="padding: 0;">
                  <div class="form-row no-padding no-margin">
                    <div
                      class="form-group col-4"
                      style="padding: 0;">
                      <div
                        class="box-input"
                        style="border-radius: 0;">
                        <vs-checkbox
                          v-model="settings.table.is_active"
                          :disabled="settings.menu_online.is_active"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          <span v-if="!settings.table.is_active">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                    <div
                      class="form-group col-8"
                      style="padding-left: 0;padding-right: 0;"
                    >
                      <div
                        class="box-input active"
                        style="
                          border-radius: 0px .25rem .25rem 0;
                          border-left: 0;
                          padding-right: 3px;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                      >
                        <span>
                          {{ $t('apps.pos.message.orderrefname') }} "{{ getMasterDataText(settings.table.ref_name, $t) }}"
                        </span>
                        <button
                          class="btn btn-light"
                          style="height: 28px;font-size: 11px;box-shadow: none;"
                          @click="handleOpenTableMasterData"
                        >
                          {{ $t('message.managemasterdata', { number: settings.table.lists.length }) }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6"/>
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.usefeaturedining') }}
                </div>
                <div
                  class="form-group col-12 mb-0"
                  style="padding: 0;">
                  <div class="form-row no-padding no-margin">
                    <div
                      class="form-group col-4"
                      style="padding: 0;">
                      <div
                        class="box-input"
                        style="border-radius: 0;">
                        <vs-checkbox
                          v-model="settings.dining.is_active"
                          :disabled="settings.menu_online.is_active"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;"
                        >
                          <span v-if="!settings.dining.is_active">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                    <div
                      class="form-group col-8"
                      style="padding-left: 0;padding-right: 0;"
                    >
                      <div
                        class="box-input active"
                        style="
                          border-radius: 0px .25rem .25rem 0;
                          border-left: 0;
                          padding-right: 3px;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                      >
                        <span>
                          {{ $t('message.defaultby', { value: defaultDining }) }}
                        </span>
                        <button
                          class="btn btn-light"
                          style="height: 28px;font-size: 11px;box-shadow: none;"
                          @click="handleOpenDiningMasterData"
                        >
                          {{ $t('message.managemasterdata', { number: settings.dining.options.length }) }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6"/>
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.usefeaturecustomer') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <div class="box-input">
                    <vs-checkbox
                      v-model="settings.customer.is_active"
                      color="#A3CA76"
                      style="float: left;position: relative;top: 1px;left: -5px;">
                      <span v-if="!settings.customer.is_active">{{ $t('message.disabled') }}</span>
                      <span v-else>{{ $t('message.enabled') }}</span>
                    </vs-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-md-6"/>
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.usefeaturepaymentmethod') }}
                </div>
                <div
                  class="form-group col-12 mb-0"
                  style="padding: 0;">
                  <div class="form-row no-padding no-margin">
                    <div
                      class="form-group col-4"
                      style="padding: 0;">
                      <div
                        class="box-input"
                        style="border-radius: 0;">
                        <vs-checkbox
                          v-model="settings.payment.is_active"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;"
                          @change="handlePaymentMethodChange"
                        >
                          <span v-if="!settings.payment.is_active">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                    <div
                      class="form-group col-8"
                      style="padding-left: 0;padding-right: 0;"
                    >
                      <div
                        class="box-input active"
                        style="
                          border-radius: 0px .25rem .25rem 0;
                          border-left: 0;
                          padding-right: 3px;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                      >
                        <span>
                          {{ $t('message.defaultby', { value: defaultPaymentMethod }) }}
                        </span>
                        <button
                          class="btn btn-light"
                          style="height: 28px;font-size: 11px;box-shadow: none;"
                          @click="handleOpenPaymentMasterData"
                        >
                          {{ $t('message.managemasterdata', { number: settings.payment.methods.length }) }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6"/>
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('message.roundingdecimals') }}
                </div>
                <div
                  class="form-group col-12 mb-0"
                  style="padding: 0;">
                  <div class="form-row no-padding no-margin">
                    <div
                      class="form-group col-4"
                      style="padding: 0;">
                      <div
                        class="box-input"
                        style="border-radius: 0;">
                        <vs-checkbox
                          v-model="settings.format_number.is_round"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          <span v-if="!settings.format_number.is_round">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                    <div
                      class="form-group col-8"
                      style="padding-left: 0;padding-right: 0;">
                      <div
                        class="box-input active"
                        style="border-radius: 0px .25rem .25rem 0;border-left: 0;">
                        <span v-if="!settings.format_number.is_round">{{ $t('message.formatnumberpreview', {
                          string:
                            '479.50'
                        }) }}</span>
                        <span v-else>{{ $t('message.formatnumberpreview', { string: '479.50 = 480' }) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('message.disabledsalewhenproductoutofstock') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <div class="form-row no-padding no-margin">
                    <div
                      class="form-group col-4 no-margin"
                      style="padding: 0;">
                      <div
                        class="box-input"
                        style="border-radius: 0;">
                        <vs-checkbox
                          v-model="settings.product_out_of_stock.sale_disabled"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          <span v-if="!settings.product_out_of_stock.sale_disabled">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                    <div
                      class="form-group col-8 no-margin"
                      style="padding-left: 0;padding-right: 0;position: relative;">
                      <div style="position: absolute; top: 7px; left: 10px; font-size: 14px;">
                        &lt;=
                      </div>
                      <input
                        v-model="settings.product_out_of_stock.count"
                        type="text"
                        class="form-control text-right text-select-all"
                        style="border-left: none;border-radius: 0 .25rem .25rem 0;padding-left: 32px;"
                        @keypress="numberOnly"
                        @keyup="settings.product_out_of_stock.count = setToValidNumber(settings.product_out_of_stock.count)"
                        @blur="settings.product_out_of_stock.count = setToCustomDigitsNumber(settings.product_out_of_stock.count, { decimal: 0 })">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6"/>
            </div>
          </div>
        </section>
        <section class="col-12 no-padding">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('apps.pos.message.menuonline')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.defaultqrcodeappprovider') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <select
                    v-model="settings.menu_online.default_app_provider"
                    class="custom-select form-control">
                    <option value="web">{{ $t('apps.pos.message.defaultqrcodeappproviderweb') }}</option>
                    <option value="line">{{ $t('apps.pos.message.defaultqrcodeappproviderline') }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.defaultqrcodetype') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <select
                    v-model="settings.menu_online.default_qrcode_type"
                    class="custom-select form-control">
                    <option value="one_time_use">{{ $t('apps.pos.message.qrcodetypeonetimeuse') }}</option>
                    <option value="reusable">{{ $t('apps.pos.message.qrcodetypereusable') }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.defaultqrcoderequestapproveacess') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <div class="box-input">
                    <vs-checkbox
                      v-model="settings.menu_online.default_is_client_approve_access_required"
                      color="#A3CA76"
                      style="float: left;position: relative;top: 1px;left: -5px;">
                      <span v-if="!settings.menu_online.default_is_client_approve_access_required">{{ $t('message.no') }}</span>
                      <span v-else>{{ $t('message.yes') }}</span>
                    </vs-checkbox>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.defaultqrcoderequestapproveorder') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <div class="box-input">
                    <vs-checkbox
                      v-model="settings.menu_online.default_is_client_approve_order_required"
                      color="#A3CA76"
                      style="float: left;position: relative;top: 1px;left: -5px;">
                      <span v-if="!settings.menu_online.default_is_client_approve_order_required">{{ $t('message.no') }}</span>
                      <span v-else>{{ $t('message.yes') }}</span>
                    </vs-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.defaultqrcodeexpiretime') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <input
                    v-model="settings.menu_online.default_qrcode_expire_min"
                    type="text"
                    class="form-control number-only text-select-all"
                    @keypress="numberOnly">
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-6">
                <div
                  class="col-md-12 no-padding"
                  style="height: 24px;">
                  {{ $t('apps.pos.message.playalertsound') }}
                </div>
                <div
                  class="form-group col-12"
                  style="padding: 0;">
                  <div class="box-input">
                    <vs-checkbox
                      v-model="settings.menu_online.play_alert_sound.is_active"
                      color="#A3CA76"
                      style="float: left;position: relative;top: 1px;left: -5px;">
                      <span v-if="!settings.menu_online.play_alert_sound.is_active">{{ $t('message.no') }}</span>
                      <span v-else>{{ $t('message.yes') }}</span>
                    </vs-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-12 no-padding">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('apps.pos.message.receipttemplate')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('message.logo') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-3"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="height: 92px;border-radius: 0;display: flex;">
                            <vs-checkbox
                              v-model="settings.receipt.shop_logo.is_active"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.shop_logo.is_active">{{ $t('apps.pos.message.show') }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                        <div
                          class="form-group col-9"
                          style="padding-left: 0;padding-right: 0;position: relative;">
                          <template>
                            <file-pond
                              v-if="isShowFilePond"
                              ref="pond"
                              :server="{ process, revert, restore, load, fetch }"
                              name="file"
                              className="my-pond"
                              acceptedFileTypes="image/jpeg, image/png"
                              imagePreviewHeight="60"
                              imageCropAspectRatio="1:1"
                              labelIdle="อัพโหลดรูปภาพ"
                              labelTapToUndo=""
                              labelTapToCancel="คลิกเพื่อยกเลิก"
                              labelFileProcessing="กำลังอัปโหลด"
                              labelFileLoading="กำลังโหลด"
                              labelFileProcessingComplete=""
                              labelButtonRemoveItem="นำออก"
                              labelFileProcessingError="เกิดข้อผิดพลาด"
                              labelButtonAbortItemProcessing="ยกเลิก" />
                            <div
                              v-else
                              style="width: 100%;height: 92px;padding: 15px 0;position: relative;display: flex;justify-content: flex-start;border: 1px solid #ced4da;border-left: 0;background-color: #fff;">
                              <div>
                                <img
                                  :src="settings.receipt.shop_logo.value"
                                  class="col-12"
                                  style="height: 100%; width: auto;">
                              </div>
                              <div style="width: 28px; position: absolute; top: 5px; right: 5px; text-align: right;">
                                <button
                                  class="btn btn-sm btn-close-image"
                                  @click="closeUploadedImage()">
                                  <i class="fas fa-times"/>
                                </button>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('message.shopname') }} *
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-3"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.shop_name.is_active"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.shop_name.is_active">{{ $t('apps.pos.message.show') }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                        <div
                          class="form-group col-9"
                          style="padding-left: 0;padding-right: 0;position: relative;">
                          <input
                            :class="[
                              'form-control',
                              !settings.receipt.shop_name.value.trim().length && 'is-invalid'
                            ]"
                            :style="`border-radius: 0 .25rem .25rem 0;padding-left: 15px;${settings.receipt.shop_name.value.trim().length && 'border-left: none;'}`"
                            :placeholder="$t('placeholder.filltext')"
                            v-model="settings.receipt.shop_name.value"
                            type="text" >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('message.address') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-3"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.shop_address.is_active"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.shop_address.is_active">{{ $t('apps.pos.message.show')
                              }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                        <div
                          class="form-group col-9"
                          style="padding-left: 0;padding-right: 0;position: relative;">
                          <input
                            :placeholder="$t('placeholder.filltext')"
                            v-model="settings.receipt.shop_address.value"
                            type="text"
                            class="form-control"
                            style="border-left: none;border-radius: 0 .25rem .25rem 0;padding-left: 15px;" >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('message.taxpayerno') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-3"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.shop_tax_id.is_active"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.shop_tax_id.is_active">{{ $t('apps.pos.message.show')
                              }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                        <div
                          class="form-group col-9"
                          style="padding-left: 0;padding-right: 0;position: relative;">
                          <input
                            :placeholder="$t('placeholder.filltext')"
                            v-model="settings.receipt.shop_tax_id.value"
                            type="text"
                            class="form-control"
                            style="border-left: none;border-radius: 0 .25rem .25rem 0;padding-left: 15px;" >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    v-if="settings.receipt.shop_tax_id.is_active"
                    class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('apps.pos.message.showtaxtitle') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-12"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.shop_tax_title.is_active"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.shop_tax_title.is_active">{{ $t('apps.pos.message.show')
                              }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('message.tel') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-3"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.shop_tel.is_active"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.shop_tel.is_active">{{ $t('apps.pos.message.show') }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                        <div
                          class="form-group col-9"
                          style="padding-left: 0;padding-right: 0;position: relative;">
                          <input
                            :placeholder="$t('placeholder.filltext')"
                            v-model="settings.receipt.shop_tel.value"
                            type="text"
                            class="form-control"
                            style="border-left: none;border-radius: 0 .25rem .25rem 0;padding-left: 15px;" >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('apps.pos.message.orderno') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-12"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.order_no"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.order_no">{{ $t('apps.pos.message.show') }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('message.customername') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-12"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.customer_name"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.customer_name">{{ $t('apps.pos.message.show') }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('apps.pos.message.textfooter') }}
                    </div>
                    <div
                      class="form-group col-12 m-0"
                      style="padding: 0;">
                      <div class="form-row no-padding no-margin">
                        <div
                          class="form-group col-3"
                          style="padding: 0;">
                          <div
                            class="box-input"
                            style="border-radius: 0;">
                            <vs-checkbox
                              v-model="settings.receipt.text_footer.is_active"
                              color="#A3CA76"
                              style="float: left;position: relative;top: 1px;left: -5px;">
                              <span v-if="settings.receipt.text_footer.is_active">{{ $t('apps.pos.message.show')
                              }}</span>
                              <span v-else>{{ $t('apps.pos.message.hide') }}</span>
                            </vs-checkbox>
                          </div>
                        </div>
                        <div
                          class="form-group col-9"
                          style="padding-left: 0;padding-right: 0;position: relative;">
                          <input
                            :placeholder="$t('placeholder.filltext')"
                            v-model="settings.receipt.text_footer.value"
                            type="text"
                            class="form-control"
                            style="border-left: none;border-radius: 0 .25rem .25rem 0;padding-left: 15px;" >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-2">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('apps.pos.message.papersize') }}</label>
                        <select
                          v-model="settings.print.paper_size"
                          class="custom-select form-control">
                          <option value="58mm">58mm</option>
                          <option value="80mm">80mm</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-2">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('apps.pos.message.fontsize') }}</label>
                        <select
                          v-model="settings.receipt.font_size"
                          class="custom-select form-control">
                          <option :value="50">50%</option>
                          <option :value="60">60%</option>
                          <option :value="70">70%</option>
                          <option :value="80">80%</option>
                          <option :value="90">90%</option>
                          <option :value="100">100%</option>
                          <option :value="110">110%</option>
                          <option :value="120">120%</option>
                          <option :value="130">130%</option>
                          <option :value="140">140%</option>
                          <option :value="150">150%</option>
                          <option :value="160">160%</option>
                          <option :value="170">170%</option>
                          <option :value="180">180%</option>
                          <option :value="190">190%</option>
                          <option :value="200">200%</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-6"
                style="padding: 24px 40px;">
                <BasePosReceiptPreview
                  :receiptReviewInfo="receiptReviewInfo"
                  :paperSize="settings.print.paper_size"
                  :fontSize="settings.receipt.font_size"
                  @onPrint="handlePrint" />
              </div>
            </div>
          </div>
        </section>
        <section class="col-12 no-padding">
          <div class="col-md-12 no-padding">
            <section-header :title="$t('apps.pos.message.issuingreceipt')"/>
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-row">
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('apps.pos.message.autosentreceiptemail') }}
                    </div>
                    <div
                      class="form-group col-12"
                      style="padding: 0;">
                      <div class="box-input">
                        <vs-checkbox
                          v-model="settings.email_receipt.auto"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          <span v-if="!settings.email_receipt.auto">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('apps.pos.message.autoshowqrcodereceipt') }}
                    </div>
                    <div
                      class="form-group col-12"
                      style="padding: 0;">
                      <div class="box-input">
                        <vs-checkbox
                          v-model="settings.qrcode_receipt.auto"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          <span v-if="!settings.qrcode_receipt.auto">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('apps.pos.message.autoprint') }}
                    </div>
                    <div
                      class="form-group col-12"
                      style="padding: 0;">
                      <div class="box-input">
                        <vs-checkbox
                          v-model="settings.print.auto"
                          color="#A3CA76"
                          style="float: left;position: relative;top: 1px;left: -5px;">
                          <span v-if="!settings.print.auto">{{ $t('message.disabled') }}</span>
                          <span v-else>{{ $t('message.enabled') }}</span>
                        </vs-checkbox>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div
                      class="col-md-12 no-padding"
                      style="height: 24px;">
                      {{ $t('apps.pos.message.printcopies') }}
                    </div>
                    <div
                      class="form-group col-12"
                      style="padding: 0;">
                      <select
                        v-model="settings.print.copies"
                        class="custom-select form-control">
                        <option
                          v-for="i in 5"
                          :value="i"
                          :key="i"
                        >
                          {{ i }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section class="col-12 action-bar">
          <div
            v-if="!$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              :disabled="disabled.btn_save"
              class="btn btn-web"
              @click="update">{{ $t('button.save') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="col-md-12 text-right">
            <button
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </section>
      </template>

    </div>

    <!-- Using for printing -->
    <receipt-view
      v-if="ready"
      :shop_logo="receiptReviewInfo.shopLogo"
      :shop_name="receiptReviewInfo.shopName"
      :shop_address="receiptReviewInfo.shopAddress"
      :shop_tax_id="receiptReviewInfo.shopTaxId"
      :shop_tax_title="receiptReviewInfo.shopTaxTitle"
      :shop_tel="receiptReviewInfo.shopTel"
      :orders="receiptReviewInfo.orders"
      :total_price="receiptReviewInfo.totalPrice"
      :receipt_info="receiptReviewInfo.receiptInfo"
      :date_time="receiptReviewInfo.dateTime"
      :text_footer="receiptReviewInfo.textFooter"
      :font_size="settings.receipt.font_size"
      style="position: fixed;z-index: -1;top: 1mm;left: 1mm;font-family: tahoma;color: black;width: 100%;"
      class="receipt-template" />

    <BaseModalCustomMasterData
      v-if="ready"
      :list="settings.payment.methods"
      :id="MODAL_PAYMENT_MASTER_DATA"
      :headerText="$t('apps.pos.message.managepaymentmethods')"
      @onClose="handleClosePaymentMasterData"
      @onSubmit="handleSubmitPaymentMasterData"
    />

    <BaseModalCustomMasterData
      v-if="ready"
      :list="settings.dining.options"
      :id="MODAL_DINING_MASTER_DATA"
      :headerText="$t('apps.pos.message.managediningoptions')"
      @onClose="handleCloseDiningMasterData"
      @onSubmit="handleSubmitDiningMasterData"
    />

    <BaseModalCustomMasterData
      v-if="ready"
      :list="settings.table.lists.map((item) => ({
        ...item,
        deletable: true,
      }))"
      :topBodyProps="{
        ref_name: getMasterDataText(settings.table.ref_name, $t),
      }"
      :id="MODAL_TABLE_MASTER_DATA"
      :headerText="$t('apps.pos.message.managetablelists')"
      :showCheckboxDefault="false"
      :master-data-title="$t('apps.pos.message.masterdatalist')"
      @onClose="handleCloseTableMasterData"
      @onSubmit="handleSubmitTableMasterData"
    >
      <template #body-top="{ topBodyProps }">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>
                {{ $t('apps.pos.message.orderrefname') }}
              </label>
              <input
                v-model="topBodyProps.ref_name"
                type="text"
                class="form-control">
              <small
                id="emailHelp"
                class="form-text text-muted">
                {{ $t('apps.pos.message.orderrefhelpertext') }}
              </small>
            </div>
          </div>
        </div>
      </template>
    </BaseModalCustomMasterData>

    <BaseConfirmDiscardModal
      v-if="ready"
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal" />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

import sidebarModule from './../../sidebarModule'

import BasePosReceiptPreview from '@/components/base/BasePosReceiptPreview.vue'
import receiptView from '@/components/custom/print/pos/Receipt.vue'

import discardFormMixin from '@/mixins/discardForm'
import { POS_PAYMENT_METHOD } from '../../../../helpers/enum'
import { getMasterDataText } from '../../../../helpers'

export default {
  name: 'PosConfigurationSetting',

  components: {
    BasePosReceiptPreview,
    receiptView,
  },

  mixins: [discardFormMixin],

  data () {
    return {
      getMasterDataText,
      POS_PAYMENT_METHOD: POS_PAYMENT_METHOD,

      ready: false,

      edited: true,

      settings: {},
      original_settings: {},

      fileUpload: {
        logo: [
          {
            type: 'original',
            location: null,
          },
          {
            type: 'thumbnail',
            location: null,
          },
        ],
      },

      isShowFilePond: false,

      disabled: {
        btn_save: false,
      },

      MODAL_PAYMENT_MASTER_DATA: 'MODAL_PAYMENT_MASTER_DATA',
      MODAL_DINING_MASTER_DATA: 'MODAL_DINING_MASTER_DATA',
      MODAL_TABLE_MASTER_DATA: 'MODAL_TABLE_MASTER_DATA',
    }
  },

  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      posSettings: 'getPosSetting',
      currency: 'getCurrency',
      getShopContact: 'getShopContact',
      getShopContactIdByPlatform: 'getShopContactIdByPlatform',
    }),
    getUpdateSettings () {
      // end this line
      if (!this.ready) return null

      const cloneSettings = _.cloneDeep(this.settings)
      delete cloneSettings.pin

      return {
        ...cloneSettings,
        receipt: {
          is_show_logo: cloneSettings.receipt.shop_logo.is_active,
          is_show_name: cloneSettings.receipt.shop_name.is_active,
          is_show_address: cloneSettings.receipt.shop_address.is_active,
          is_show_tax_id: cloneSettings.receipt.shop_tax_id.is_active,
          is_show_tax_title: cloneSettings.receipt.shop_tax_title.is_active,
          is_show_tel: cloneSettings.receipt.shop_tel.is_active,
          is_show_order_no: cloneSettings.receipt.order_no,
          is_show_customer_name: cloneSettings.receipt.customer_name,
          text_footer: {
            is_active: cloneSettings.receipt.text_footer.is_active,
            value: cloneSettings.receipt.text_footer.value,
          },
          font_size: cloneSettings.receipt.font_size,
        },
        dining: {
          is_active: cloneSettings.dining.is_active,
          options: this.settings.dining.options,
        },
        payment: {
          is_active: cloneSettings.payment.is_active,
          methods: this.settings.payment.methods,
        },
        menu_online: {
          ...cloneSettings.menu_online,
          default_qrcode_expire_min: Number(cloneSettings.menu_online.default_qrcode_expire_min),
        },
      }
    },
    getUpdateShopInfo () {
      return {
        ...(
          (() => {
            if ((this.fileUpload.logo[0].location && this.fileUpload.logo[1].location) || this.settings.receipt.shop_logo.value === null) {
              return {
                logo: {
                  original: this.fileUpload.logo[0].location,
                  thumbnail: this.fileUpload.logo[1].location,
                },
              }
            }
            return null
          })()
        ),
        shop_name: this.settings.receipt.shop_name.value,
        location: {
          address: this.settings.receipt.shop_address.value,
        },
        vat: {
          taxpayer_no: this.settings.receipt.shop_tax_id.value || null,
        },
        contacts: this.dataSetContacts,
      }
    },
    dataSetContacts () {
      let dataSet = {}
      let shopInfo = this.shopInfo
      let form = {
        contacts: {
          tel: this.settings.receipt.shop_tel.value,
        },
      }

      let shopInfoContact = this.getShopContact(shopInfo.contacts)

      dataSet['contacts'] = {
        'insert': [],
        'update': [],
        'delete': [],
      }

      if (shopInfoContact.tel == null) {
        if (form.contacts.tel !== shopInfoContact.tel) {
          if (form.contacts.tel.trim().length > 0) {
            dataSet['contacts'].insert.push({
              'platform': 'tel',
              'source': form.contacts.tel,
            })
          }
        }
      } else {
        if (form.contacts.tel !== shopInfoContact.tel) {
          if (form.contacts.tel.trim().length > 0) {
            dataSet['contacts'].update.push({
              'contact_id': this.getShopContactIdByPlatform('tel', shopInfo.contacts),
              'platform': 'tel',
              'source': form.contacts.tel,
            })
          } else {
            dataSet['contacts'].delete.push({
              'contact_id': this.getShopContactIdByPlatform('tel', shopInfo.contacts),
            })
          }
        }
      }

      return dataSet.contacts
    },
    receiptReviewInfo () {
      return {
        shopLogo: (() => {
          if (this.settings.receipt.shop_logo.is_active && this.settings.receipt.shop_logo.value) {
            return this.settings.receipt.shop_logo.value
          }
        })(),
        shopName: (() => {
          if (this.settings.receipt.shop_name.is_active && this.settings.receipt.shop_name.value) {
            return this.settings.receipt.shop_name.value
          }
        })(),
        shopAddress: (() => {
          if (this.settings.receipt.shop_address.is_active && this.settings.receipt.shop_address.value) {
            return this.settings.receipt.shop_address.value
          }
        })(),
        shopTaxId: (() => {
          if (this.settings.receipt.shop_tax_id.is_active && this.settings.receipt.shop_tax_id.value) {
            return this.settings.receipt.shop_tax_id.value
          }
        })(),
        shopTaxTitle: (() => {
          if (this.settings.receipt.shop_tax_id.is_active && this.settings.receipt.shop_tax_id.value) {
            return this.settings.receipt.shop_tax_title.is_active
          }
        })(),
        shopTel: (() => {
          if (this.settings.receipt.shop_tel.is_active && this.settings.receipt.shop_tel.value) {
            return this.settings.receipt.shop_tel.value
          }
        })(),
        orders: [
          {
            posbio_id: null,
            item: this.$t('apps.pos.message.demoproductname'),
            price: 999,
            cost: null,
            quantity: 1,
            note: null,
            sku_id: null,
            modifiers: [
              {
                'options': [],
              },
            ],
            discounts: [],
            taxes: [],
          },
        ],
        totalPrice: {
          discount: 0,
          tax: 0,
          total: 999,
        },
        receiptInfo: {
          ps_code: (() => {
            const y = this.moment().format('YYYY')
            const m = this.moment().format('MM')
            const d = this.moment().format('DD')
            return `POS/STORE/${y}/${m}/${d}/01`
          })(),
          bi_code: (() => {
            if (this.settings.receipt.order_no) {
              return '9'
            }
          })(),
          paymentMethod: POS_PAYMENT_METHOD.CASH,
          customer: {
            customer_name: (() => {
              if (this.settings.receipt.customer_name) {
                return this.$t('apps.pos.message.democustomername')
              }
            })(),
          },
          paid: 1000,
          change: 1,
        },
        textFooter: (() => {
          if (this.settings.receipt.text_footer.is_active && this.settings.receipt.text_footer.value) {
            return this.settings.receipt.text_footer.value
          }
        })(),
        dateTime: this.moment(new Date()).format('H:mm'),
      }
    },
    isValidForm () {
      if (!this.settings.receipt.shop_name.value.trim().length) {
        return false
      }
      return true
    },
    form () {
      return {
        settings: this.settings,
      }
    },
    defaultPaymentMethod () {
      const name = this.settings.payment.methods.find((item) => item.is_default).name
      return getMasterDataText(name, this.$t)
    },
    defaultDining() {
      const name = this.settings.dining.options.find((item) => item.is_default).name
      return getMasterDataText(name, this.$t)
    },
  },

  methods: {
    ...mapActions([
      'setPosSection',
      'getProducts',
      'updateSettingsPOS',
      'updateShop',
    ]),
    async update () {
      if (!this.isValidForm) {
        // eslint-disable-next-line no-undef
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      const [responseUpdatePos, responseUpdateShop] = await Promise.all([
        this.updateSettingsPOS(this.getUpdateSettings),
        this.updateShop(this.getUpdateShopInfo),
      ])

      if (responseUpdatePos.success && responseUpdateShop.success) {
        this.edited = false
        this.original_settings = _.cloneDeep(this.settings)
        this.isShowFilePond = this.settings.receipt.shop_logo.value === null
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        this.$nextTick(() => {
          this.edited = true
        })
      }

      this.showFinish(this.$Progress)
    },
    closeUploadedImage () {
      this.isShowFilePond = true
      this.settings.receipt.shop_logo.value = null
    },
    async checkToDeleteS3Images () {
      if (!this.fileUpload.logo[0].location && !this.fileUpload.logo[1].location) {
        return false
      }

      var dataSet = {
        'bucket': null,
        'objects': [],
      }

      this.fileUpload.logo.map((img, idx) => {
        let bucket = this.getS3Bucket(img.location)
        let key = this.getS3Key(img.location)

        if (!dataSet.bucket) {
          dataSet.bucket = bucket
        }

        dataSet.objects.push({
          'key': key,
        })
      })

      await this.$store.dispatch('deleteImage', dataSet)

      // set images location to null
      this.fileUpload.logo[0].location = null
      this.fileUpload.logo[1].location = null
    },
    async process (fieldName, file, metadata, load, error, progress, abort) {
      var that = this

      this.disabled.btn_save = true

      try {
        progress(true, 0, 1024)

        var formData = new FormData()
        formData.append(fieldName, file, file.name)

        let res = await that.$store.dispatch('uploadImage', formData)

        if (!res.success) {
          error(res.error)
        }

        res.data.map(img => {
          if (img.type === 'original') {
            that.fileUpload.logo[0].location = img.location
          }
          if (img.type === 'thumbnail') {
            that.fileUpload.logo[1].location = img.location
            this.settings.receipt.shop_logo.value = img.location
          }
        })

        load('success')

        this.disabled.btn_save = false

        return { abort: () => { abort() } }
      } catch (e) {
        return { abort: () => { abort() } }
      }
    },
    async revert (uniqueFileId, load, error) {
      this.disabled.btn_save = true
      await this.checkToDeleteS3Images()
      this.disabled.btn_save = false
      this.settings.receipt.shop_logo.value = null
    },
    load (uniqueFileId, load, error) {
      error()
    },
    fetch (url, load, error, progress, abort, headers) {
      error('Solo archivos locales')
    },
    restore (uniqueFileId, load, error, progress, abort, headers) {
      error()
    },
    handlePrint () {
      // eslint-disable-next-line no-undef
      $('.receipt-template').printThis()
    },
    handleOpenPaymentMasterData() {
      $(`#${this.MODAL_PAYMENT_MASTER_DATA}`).modal('show')
    },
    handleClosePaymentMasterData() {
      this.settings.payment.methods = _.cloneDeep(this.original_settings.payment.methods)
      $(`#${this.MODAL_PAYMENT_MASTER_DATA}`).modal('hide')
    },
    async handleSubmitPaymentMasterData(payload) {
      this.settings.payment.methods = _.cloneDeep(payload)
      this.original_settings.payment.methods = _.cloneDeep(payload)
      // await this.updatePaymentMethods(payload)
      $(`#${this.MODAL_PAYMENT_MASTER_DATA}`).modal('hide')
    },
    handlePaymentMethodChange(event) {
      // for better ux
      if (event.target.checked === false) {
        this.settings.payment.methods = this.settings.payment.methods.map((item) => {
          return {
            ...item,
            is_default: (() => {
              if (item.name === '{cash}') {
                return true
              }
              return false
            })(),
          }
        })
        this.original_settings.payment.methods = _.cloneDeep(this.settings.payment.methods)
      }
    },
    handleOpenDiningMasterData() {
      $(`#${this.MODAL_DINING_MASTER_DATA}`).modal('show')
    },
    handleCloseDiningMasterData() {
      this.settings.dining.options = _.cloneDeep(this.original_settings.dining.options)
      $(`#${this.MODAL_DINING_MASTER_DATA}`).modal('hide')
    },
    async handleSubmitDiningMasterData(payload) {
      this.settings.dining.options = _.cloneDeep(payload)
      this.original_settings.dining.options = _.cloneDeep(payload)
      // await this.updatePaymentMethods(payload)
      $(`#${this.MODAL_DINING_MASTER_DATA}`).modal('hide')
    },
    handleOpenTableMasterData() {
      $(`#${this.MODAL_TABLE_MASTER_DATA}`).modal('show')
    },
    handleCloseTableMasterData() {
      this.settings.table.lists = _.cloneDeep(this.original_settings.table.lists)
      $(`#${this.MODAL_TABLE_MASTER_DATA}`).modal('hide')
    },
    async handleSubmitTableMasterData(payload, { topBodyProps: { ref_name } }) {
      const newPayload = payload.map((item) => {
        return {
          name: item.name,
          is_active: item.is_active,
          connect: item.connect
            ? { ...item.connect }
            : undefined,
        }
      })
      this.settings.table.ref_name = _.cloneDeep(ref_name)
      this.settings.table.lists = _.cloneDeep(newPayload)
      this.original_settings.table.ref_name = _.cloneDeep(ref_name)
      this.original_settings.table.lists = _.cloneDeep(newPayload)
      $(`#${this.MODAL_TABLE_MASTER_DATA}`).modal('hide')
    },
  },

  watch: {
    ready () {
      this.showFinish(this.$Progress)
    },
  },

  async created () {
    await this.$store.dispatch('setLocalStorageShopInfo')

    // set settings
    this.settings = _.cloneDeep(this.posSettings)
    this.original_settings = _.cloneDeep(this.posSettings)

    if (!this.settings.receipt.shop_logo.value) {
      this.isShowFilePond = true
    }

    // set ready
    this.ready = true
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },
}
</script>

<style scoped>
.main .top-bar {
  width: 100%;
  height: 60px;
  position: fixed;
  z-index: 1;
  top: 60px;
  background: #FFF;
  border-bottom: solid 1px #D8E2E7;
  font-size: 18px;
  color: var(--text-color);
}

.main .top-bar .sitemap i {
  position: relative;
  top: 2px;
  margin-top: 0;
  font-size: 24px;
  margin-right: 4px;
}

.main .top-bar .action .item>button {
  padding: 0 10px 0 10px;
  float: right;
  border-left: solid 1px #D8E2E7;
  border-radius: 0;
}

.main .top-bar .action .item:last-of-type>button {
  border-left: none;
}

.main .content {
  position: relative;
  top: 120px;
  padding-top: 15px;
  overflow: auto;
}

.box-input {
  position: relative;
  padding-left: 7px;
  height: 35px;
  background: #fff;
  border: 1px solid #ced4da;
  color: #495057;
  line-height: 35px;
  border-radius: .25rem;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-input.active {
  background: #e9ecef;
  border-radius: .25rem;
}

.content>>>.filepond--root {
  height: 92px;
  max-height: 92px;
}

.content>>>.filepond--root .filepond--drop-label {
  min-height: 92px;
}

.content>>>.filepond--panel-root {
  border-radius: 0 4px 4px 0;
  border: 1px solid #ced4da;
  border-left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/configuration/Setting.vue